import { buildRouteTree } from "@remar/shared/dist/utils/routeUtils";

export const routes = buildRouteTree({
	banners: null,
	books: null,
	catAvailability: null,
	communityPool: null,
	coupons: null,
	course: null,
	courseAddEdit: null,
	createLesson: null,
	discussionBoard: null,
	fileVault: null,
	gifts: null,
	home: null,
	invitation: null,
	lesson: null,
	location: null,
	manageLocations: null,
	manageSchools: null,
	manageStudents: {
		subscriptionCancellations: null
	},
	manageSubjects: null,
	manageTutorial: null,
	manageAdmins: null,
	mediaLibrary: null,
	newReports: null,
	notifications: null,
	questionbank: null,
	reports: null,
	settings: null,
	signIn: null,
	signUp: null,
	students: null,
	tags: null,
	videos: null,
	stream: {
		createNew: null,
		join: null
	}
});

export const GLOBAL_CONSTANTS = {
	ANT_MEDIA_SERVER_URL: process.env.REACT_APP_ANT_MEDIA_SERVER_URL,
	ICE_SERVERS: process.env.REACT_APP_ICE_SERVERS,
	CLIENT_APP_URL: process.env.REACT_APP_CLIENT_URL,
	ANT_MEDIA_SERVER_STATISTICS_URL: process.env.REACT_APP_ANT_MEDIA_SERVER_API_URL
};
